/**
 * Author:Murugaeswari
 * Modified by:kani,Murugaeswari
 * Modified Date: 2025-05-05
 */
// Checkout.js
import React, { useRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, FormFeedback ,Row,Col} from "reactstrap";
import * as Yup from "yup";
import { getLoggedInUser } from "../../helpers/fakebackend_helper"
import * as url from "../../../src/helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {RAZORPAY_KEY} from '../../constants/commonVariable'
import Spinners from "../../components/Common/Spinner";
import './PricingPlans.css';


import ConfirmModal from "../../components/Common/ConfirmModal";
const Checkout = forwardRef((props, ref) => {
  const scrollRef = useRef();

  const [subjectList, setSubjectList ] = useState([]);
  const [boardList, setBoardList ] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [options, setOptions] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [selectedcategoryPlan, setSelectedcategoryPlan] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);  
  const [subscribedCategoryList, setSubscribedCategoryList] = useState([]);
  const [razorpayKey, setRazorpayKey] = useState("");
  const [confirmationModalTxt, setShowConfirmModalTxt] = useState("");

  const [defaultChecked, setDefaultChecked] = useState({});
  useEffect(() => {
  
    // getCategoryMaster()
    getRazorPayKey()

  }, []);
  useImperativeHandle(ref, () => ({
    checkProfileCompetion: (plan) => checkProfileCompetion(plan)
  }));
  const getRazorPayKey = async () => {
    const user = getLoggedInUser()
    const data = {
      stid: Number(user.UserInfo.stid)
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscription/razorpayDetails', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await getRazorPayKey();
          }
        }
      }
      if (response?.data?.body?.razorpay_key) {
        
         setRazorpayKey(response?.data?.body?.razorpay_key)
       
  
      } else {
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
    console.error("student detailsAPI Error:", error);
    }
  }
  const getCategoryMaster = async (plan) => {
    const user = getLoggedInUser()
    const data = {
      stid: Number(user.UserInfo.stid),
      "plan_id": Number(plan?.plan_id),
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscription/getSubscriptionCategoryItem', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await getCategoryMaster(plan);
          }
        }
      }
      if (response?.data?.body?.categoryItem) {
        setOptions(response?.data?.body?.categoryItem);
        setSubscribedCategoryList(response?.data?.body?.list);
        // var catList = response?.data?.body?.categoryItem;
        // setRazorpayKey(response?.data?.body?.razorpay_key)
        // var subjects = catList.filter(item => item.category_id === 1);
        // var boards = catList.filter(item => item.category_id === 2);
        // setBoardList(boards)
        // setSubjectList(subjects)
  
      } else {
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
    console.error("student detailsAPI Error:", error);
    }
  }
const handleOrder = async () => {
console.log("selectedcategoryPlan",selectedcategoryPlan)

    try {
       if(selectedcategoryPlan.id=== undefined || selectedcategoryPlan.id === null || selectedcategoryPlan.id === ""){
        toast.error("Please select one option", { autoClose: 2000 });
        return;
       }
      //  const isExist = subscribedCategoryList.find(item => item.subject_board_id == selectedcategoryPlan.id);
       if(selectedcategoryPlan?.completiondate != "")
       {
        setShowConfirmModalTxt("Course will be completed on "+selectedcategoryPlan?.completiondate+ " Do you want to continue?") 
        setShowConfirmModal(true)
        return;
       }
       else if(selectedcategoryPlan?.istoday_expired == 1)
        {
         setShowConfirmModalTxt("Course will be completed today. Do you want to continue?") 
         setShowConfirmModal(true)
         return;
        }
       else{
     
        placeOrder();
       }
        
    } catch (error) {
        setLoading(false);
        setButtonDisable(false);
        console.log('Error:', error);
        alert('Payment initiation failed');
    } 
};
const placeOrder = async () => {
  try{

    setLoading(true);
    setButtonDisable(true);
    setShowPlanModal(false);
    const user = getLoggedInUser()
    const req = {
      stid: Number(user.UserInfo.stid),
      plan_id: selectedPlan.plan_id,
      category_plan_id: Number(selectedcategoryPlan.id),
      examboard_id: Number(selectedcategoryPlan.examboard_id),
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    const response = await axios.post(url.BASE_URL + 'subscription/createOrder', req, config);
 
    if (response && response?.data?.body?.statusFlag === 1) {
        // Payment initiation logic here
        const data = response.data.body;
        if (data?.order?.id) {
                const options = {
                    key: razorpayKey,  // Replace with your Razorpay Key ID
                    amount: data.order.amount,  // Amount in paise
                    currency: 'INR',
                    name: 'Subscription',
                    description: 'Subscription student id'+Number(user.UserInfo.stid),
                    order_id: data.order.id,  // Order ID returned from backend
                    handler: function (response) {
                        // Payment success handler
                        // Send payment details to backend to verify and insert into DB
                        handlePaymentSuccess(response, data.order.amount);
                    },
                    prefill: {
                        name: user?.UserInfo?.st_name,
                        email: user?.UserInfo?.st_email ,
                        contact: user?.UserInfo?.st_mobileno,
                    },
                   
                    theme: {
                        color: '#F37254',
                    },
                    modal: {
                        escape: false,
                        ondismiss: function () {
                          setLoading(false);
                          setButtonDisable(false);
                          // Handle cancellation logic here
                        },
                    },
                };
                const razorpayInstance = new window.Razorpay(options);
                razorpayInstance.open();
            }
          }
  }
  catch(error){
    setLoading(false);
    setButtonDisable(false);
    console.log('Error:', error);
    alert('Payment initiation failed');
  }
}
const checkProfileCompetion = async (plan) => {
console.log(plan,'plan')
  const user = getLoggedInUser()
  if(user?.UserInfo?.profilePercentage === undefined || user?.UserInfo?.profilePercentage === null || user?.UserInfo?.profilePercentage === "" || user?.UserInfo?.profilePercentage<100){
    toast.error("Please complete your profile", { autoClose: 2000 });
    return;
  }
 else if(user?.UserInfo?.profilePercentage == 100){
   setSelectedPlan(plan);
if(plan.category_plan != undefined && plan.category_plan != null && plan.category_plan != ""){
  setDefaultChecked(plan);
}
 
   getCategoryMaster(plan);
  //  console.log(subjectList,'subjectList')
  // if(plan.category_id === 1){
  //   setOptions(subjectList)
  // }
  // else{

  

  //    var filtered_boards = boardList.filter(item=>Number(item?.totalmarks) == Number(plan.total_marks) && Number(item?.totalquestions) == Number(plan.total_questions) && Number(item?.duration) == Number(plan.test_duration))
  
  //   const updatedData = filtered_boards.map(item => {
  //     // if(Number(item?.totalmarks) == Number(plan.total_marks) && Number(item?.totalquestions) == Number(plan.total_questions) && Number(item?.duration) == Number(plan.test_duration))
  //     // {
     
  //       if (item.completiondate && item.completiondate !== null && item.completiondate !== '') {
  //         const completion = new Date(item.completiondate);
        
  //         const now = new Date();
  //         now.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  //         completion.setHours(23, 59, 59, 999);
  //         const diffTime =  completion - now;
  //         const diffDays = diffTime / (1000 * 60 * 60 * 24); // Convert ms to days
      
  //         if (diffDays < plan?.validity_in_days) {
  //           return { ...item, completionoverlap: true, completed_within_days: diffDays };
  //         }
  //       }
      
  //       return item;
  //     // }
  //     });
  //     console.log(updatedData,'updatedData')    
  //   setOptions(updatedData)
  // }
  //  fetchSubscribedCategory(plan);
   setShowPlanModal(true);
 
 }
}
// const fetchSubscribedCategory = async (plan) => {
//   const user = getLoggedInUser()
//   const req = {
//     stid: Number(user.UserInfo.stid),
//     plan_id:Number(plan.plan_id),
//   }
//   const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
//   const response = await axios.post(url.BASE_URL + 'subscription/getSubscribedCategoryList', req, config);

//   if (response && response?.data?.body?.statusFlag === 3) {
//     toast.error(response.data.body.message, { autoClose: 2000 });
//     localStorage.removeItem("authUser");
//     window.location.reload();
//     return;
//   }
//   setLoading(false);

//   if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
//     const refresh = await getRefreshToken();
//     if (refresh) {
//       if (Number(refresh) === constants.invalidRefreshToken) {
//         logoutUser();
//       } else {
//         await fetchSubscribedCategory();
//       }
//     }
//   }

//   if (response && response?.data?.body?.statusFlag === 1) {
//     setSubscribedCategoryList(response.data.body.list);
//   }
// }
const handleClose = () => {
  setShowConfirmModal(!showConfirmModal);
}
const handleConfirm = () => {
  setShowConfirmModal(!showConfirmModal);
  placeOrder();
}
  
const handlePaymentSuccess = async (paymentResponse, amount) => {
  try {
     // setLoading(true);
      const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = paymentResponse;
      const user = getLoggedInUser()
      const data = {
              stid: Number(user.UserInfo.stid),
              razorpay_order_id,
              razorpay_payment_id,
              razorpay_signature
          }
      const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
      const responsePayment = await axios.post(url.BASE_URL + 'subscription/updateOrder', data,config);
        //  setLoading(false);
      if (responsePayment && responsePayment?.data?.body?.statusFlag === 1) {
  
        setButtonDisable(false);
        setLoading(false);
        toast.success(responsePayment.data.body.message, { autoClose: 2000 });

        setTimeout(() => {
          window.location.reload();
        }, 500);
        //navigate to next page
        return;
      }
      else {
        setLoading(false);
        setButtonDisable(false);
        toast.error(responsePayment.data.body.message, { autoClose: 2000 });
        return;
      }
  } catch (error) {
    setLoading(false);
      setButtonDisable(false);
      console.error('Error:', error);
      toast.error('Failed to save payment details', { autoClose: 2000 });
  } 
};
  return (
    <div className="pricing-wrapper   ">
   

      <Modal isOpen={showPlanModal}  backdrop="static" className='category-modal'  style={{width: '800px', height: '500px !important'}}>
            <ModalHeader style={{width:'100%'}} >SELECT {selectedPlan?.category_id == 1?'SUBJECT':'BOARD CATEGORY'} 
              {/* <Row style={{width:'100%'}} md={12} className="align-items-center">
                <Col md={4}>SELECT CATEGORY</Col>
                <Col md={4} style={{textAlign:'right'}}><button className='close-modal' onClick={!showPlanModal}>X</button></Col>
              </Row> */}
            </ModalHeader>
            <ModalBody style={{maxHeight: '500px !important', overflow:"scroll"}}>
            {options && options.length == 0 &&
                <div className="col-12">
                  
                      <div style={{ fontSize: '14px', fontStyle: 'italic' }}>No category found.</div>
                   
                  </div>

              }
            <div className="container mt-3">
            {options.map((option) => {
  const isMatched = subscribedCategoryList.some(item => item.subject_board_id == option.id);

  return (
    <div  key={'catoption'+option.id} >
          {
          isLoading ?
          <Spinners setLoading={setLoading} />:''

        }
          {option?.expired_flag == 0 &&
    <div
      className={`d-flex gap-2 flex-wrap align-items-start p-2 `}
      key={option.id}
      style={{ marginLeft: 0 }}
    >
      
      <input
        className="form-check-input"
        type="radio"
        name="categoryRadios"
        id={`radio${option.id}`}
        value={option.id}
         defaultChecked={defaultChecked?.sub_conf_id == option.id}
        onChange={() => {
          console.log(option, 'option')
          setSelectedcategoryPlan(option)
        }
         }
        style={{ marginTop: '4px' }}
      />

      <label
        htmlFor={`radio${option.id}`}
        className={`form-check-label ${isMatched ? 'matched-category' : ''}`}
        style={{
          cursor: 'pointer',
          textAlign: 'justify',
          maxWidth: '300px',
          wordBreak: 'break-word'
        }}
      >
        {option.name}
      </label>
      
    </div>
            }
 {/*option?.completionoverlap == true &&  */ <div  key={'compalert'+option.id} style={{marginLeft: "41px",display: "block", fontSize: "12px", fontStyle: "italic", marginTop: "-10px", marginBottom: "10px"}}>
 {option?.expired_flag == 0 && <div>
  { 
      option?.completiondate ?
       <span className="text-warning">
          Course will be completed on {option.completiondate} 
      </span>:null
  }
  {/* {option?.completed_within_days > 1 ? (
    <span className="text-danger">
      Course will be completed in {Math.round(option.completed_within_days)} days
    </span>
  ) : option?.completed_within_days > 0 && option?.completed_within_days <= 1 ? (
    <span className="text-danger">Course will be completed today</span>
  ) : (
    <span className="text-danger">Course completed</span>
  )} */}
</div>}

      </div>}
      {option?.expired_flag == 1 &&
<div
      className={`d-flex gap-2 flex-wrap align-items-start p-2 `}
      key={option.id}
      style={{ marginLeft: 0 }}
      
    >
      
      <input
        className="form-check-input"
        type="radio"
        name="categoryRadios"
        id={`radio${option.id}`}
        value={option.id}
        disabled={true}
        //  defaultChecked={defaultChecked?.sub_conf_id == option.id}
        // onChange={() => {
        //   console.log(option, 'option')
        //   setSelectedcategoryPlan(option)
        // }
        //  }
        style={{ marginTop: '4px' }}
      />
          <label
      
        className={`form-check-label ${isMatched ? 'matched-category' : ''}`}
        style={{
          cursor: 'pointer',
          textAlign: 'justify',
          maxWidth: '300px',
          wordBreak: 'break-word',
          textDecoration: 'line-through'
        }}
      >
        {option.name}
      </label>
      </div>}

      {option?.expired_flag == 1 && <div  key={'compalert'+option.id} style={{marginLeft: "41px",display: "block", fontSize: "12px", fontStyle: "italic", marginTop: "-10px", marginBottom: "10px"}}>
 <div>

       <span className="text-danger">
          Course completed.
      </span>
</div>

      </div>}
      
 </div>
  );
})}
    </div>
            </ModalBody>
            <ModalFooter>
  <div className="d-flex justify-content-between align-items-center w-100">

    {/* Legend on the left */}

  <div className="mb-2">
  {subscribedCategoryList.length > 0 &&
      <div className="d-flex gap-2 align-items-center mt-1">
        <div
          style={{
            width: '16px',
            height: '16px',
            backgroundColor: 'green',
            border: '1px solid #00acc1',
            borderRadius: '4px'
          }}
        ></div>
        <span>Already Subscribed</span>
      </div>}
    </div>
{/* :null} */}
    {/* Buttons on the right */}
    <div className="d-flex gap-2">
      <Button color="primary" onClick={() => handleOrder()} disabled={buttonDisable}>
        CONFIRM
      </Button>
      <Button color="secondary" onClick={() => setShowPlanModal(false)}>
        CLOSE
      </Button>
    </div>

  </div>
</ModalFooter>

        </Modal>
        <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
    
          <ConfirmModal title={confirmationModalTxt} show={showConfirmModal} onDeleteClick={handleConfirm} onCloseClick={handleClose} />
   
    </div>

    
  );
});
Checkout.displayName = 'Checkout';
export default Checkout;
